<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperTeacherProfiles',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'HumanResourcesModule',
    };
  },
};
</script>
